import styles from './setNewPassword.module.css';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import hide from '../Images/eye-off.svg';
import openEye from '../Images/openEye.svg';
import back from '../Images/newArrow.svg';
import logoAuth from '../Images/logo.svg';
import { toast } from '../utils/sweetAlert.ts';

function SetNewPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordTwo, setShowPasswordTwo] = useState(false);
  const navigate = useNavigate();
  const [password_one, setNewPasswordOne] = useState('');
  const [password_two, setNewPasswordTwo] = useState('');

  const [message, setMessage] = useState();
  const [messageTwo, setMessageTwo] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const validatePassword = (password) => {
    if (password.length < 8) {
      return false; 
    }
  
    let hasNumber = false;
    let hasSpecialChar = false;
    const specialChars = "!@#$%^&*";
  
    for (let char of password) {
      if (!isNaN(char)) {
        hasNumber = true; 
      } else if (specialChars.includes(char)) {
        hasSpecialChar = true; 
      }
  
      if (hasNumber && hasSpecialChar) {
        return true;
      }
    }
  
    return false;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validatePassword(password_one)) {
      console.log('testing')
      setMessage('Password requires 8 characters composing of 1 capital, number, and symbol. Please try again.');
      return;
    }

    if (password_one !== password_two) {
      setMessageTwo('Passwords do not match');
      return;
    } else {
      setMessageTwo('');
    }

    const headersList = {
      Accept: '*/*',
      'Content-Type': 'application/json',
    };
    let errorMessage = 'An unexpected error occurred';
    try {
      const response = await fetch(`${backendUrl}/reset-password`, {
        method: 'POST',
        headers: headersList,
        body: JSON.stringify({
          password: password_one,
          token,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        errorMessage = data.message || `HTTP error ${response.status}: ${response.statusText}`;
        throw new Error('HTTP error ' + response.status);
      }

      toast('success', data.message);
      navigate('/sign-in', { replace: true });
    } catch (error) {
      toast('error', errorMessage);
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.setNewPass}>
        <header>
          <div className={styles.logo}>
            <img src={logoAuth} alt="logo" className={styles.user_img} />
          </div>
          <p className={styles.heading}>Set new password</p>
          <p className={styles.subHeading}>
            Your new password must be different from <br /> previously used passwords
          </p>
        </header>
        <form onSubmit={onSubmit}>
          <label className={styles.label} htmlFor="password">
            Password
          </label>
          <div className={styles.passwordInputDiv}>
            <input
              type={showPassword ? 'text' : 'password'}
              className={styles.input}
              placeholder="Enter password"
              id="password"
              value={password_one}
              onChange={(e) => setNewPasswordOne(e.target.value)}
            />
            <img
              src={showPassword ? hide : openEye}
              alt="toggle password visibility"
              className={styles.showPassword}
              onClick={() => setShowPassword((prevState) => !prevState)}
            />
          </div>
          {message && <p className={styles.error}>{message}</p>}
          <label className={styles.label} htmlFor="password2">
            Confirm password
          </label>
          <div className={styles.passwordInputDiv}>
            <input
              type={showPasswordTwo ? 'text' : 'password'}
              className={styles.input}
              placeholder="Enter password"
              id="password2"
              value={password_two}
              onChange={(e) => setNewPasswordTwo(e.target.value)}
            />
            <img
              src={showPasswordTwo ? hide : openEye}
              alt="toggle password visibility"
              className={styles.showPassword}
              onClick={() => setShowPasswordTwo((prevState) => !prevState)}
            />
          </div>
          {messageTwo && <p className={styles.error}>{messageTwo}</p>}
          <div>
            <button className={styles.button}>Save new password</button>
          </div>
          <Link to="/sign-in" className={styles.forgotLink}>
            <div className={styles.back}>
              <img src={back} alt="back" />
              Back to login
            </div>
          </Link>
        </form>
      </div>
    </section>
  );
}

export { SetNewPassword };
